import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { AppState } from '../app.state';

import { GatewaysState } from './gateways.state';

export namespace GatewaysSelectors {
  export const gateways = (state: AppState): GatewaysState => state.gateways;

  export function getState(): MemoizedSelector<
    AppState,
    GatewaysState,
    DefaultProjectorFn<GatewaysState>
  > {
    return createSelector(gateways, (state: GatewaysState) => state);
  }
}
